import { Component, ElementRef, inject, input, viewChild } from '@angular/core';
import { SelectField } from '@prismicio/client/*';
import { BooleanField, ImageField, KeyTextField, LinkField, LinkToMediaField, Slice, TitleField } from '@prismicio/client';
import { BrowserService } from '../../../../services/browser.service';
import { RenderHtmlPipe } from '../render-html/render-html.pipe';
import { NgTemplateOutlet } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTMLMapSerializer } from '@prismicio/helpers';
import { ApplicationModalService } from '../../application-modal/application-modal.service';

@Component({
    selector: 'app-header-v2-slice',
    standalone: true,
    imports: [RenderHtmlPipe, NgTemplateOutlet, ReactiveFormsModule, FormsModule],
    templateUrl: './header-v2-slice.component.html',
    styleUrl: './header-v2-slice.component.scss'
})
export class HeaderV2SliceComponent {
    browserService = inject(BrowserService);
    private applicationModalService = inject(ApplicationModalService);
    body = input.required<HeaderSlice>();
    videoPlayer = viewChild<ElementRef<HTMLVideoElement>>('videoPlayer');
    formGroup?: FormGroup;
    name?: string;
    email?: string;

    private observer!: IntersectionObserver;

    ngOnInit() {
        if (this.browserService.isBrowser) {
            setTimeout(() => {
                this.initIntersectionObserver();
            }, 100);
        }
    }

    ngOnDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    private initIntersectionObserver() {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.25
        };

        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), options);

        if (this.videoPlayer && this.videoPlayer()?.nativeElement) {
            this.observer.observe(this.videoPlayer()!.nativeElement);

            const videoElement = this.videoPlayer()!.nativeElement;
            videoElement.pause();
        }
    }

    private handleIntersection(entries: IntersectionObserverEntry[]) {
        entries.forEach((entry) => {
            const videoElement = this.videoPlayer()?.nativeElement;
            if (!videoElement) return;

            if (entry.isIntersecting) {
                videoElement.play().catch((error) => {
                    console.warn('Video konnte nicht automatisch abgespielt werden:', error);
                });
            } else {
                videoElement.pause();
            }
        });
    }

    htmlSerializer: HTMLMapSerializer = {
        heading2: ({ children }) => `<h2 class="text-size-xl color-white">${children}</h2>`,
        paragraph: ({ children }) => `<p class="text-size-xl color-white">${children}</p>`
    };

    openApplicationModal(event: Event): void {
        event.preventDefault();
        this.applicationModalService.openModal(this.name, this.email);
    }
}

export type HeaderSlice = Slice<
    'header_v2',
    {
        mode: SelectField;
        height: SelectField;
        image: ImageField<'mobile'>;
        video: LinkToMediaField;
        heading?: KeyTextField;
        title?: TitleField;
        disable_apply_form: BooleanField;
        description: KeyTextField;
        button_title?: KeyTextField;
        button_link?: LinkField;
    },
    {
        trust_element: ImageField;
    }
>;
